import { render, staticRenderFns } from "./GffModalBlock.vue?vue&type=template&id=51fb22b1"
import script from "./GffModalBlock.vue?vue&type=script&lang=js"
export * from "./GffModalBlock.vue?vue&type=script&lang=js"
import style0 from "./GffModalBlock.vue?vue&type=style&index=0&id=51fb22b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports